export class GMResolutionsDeleteRequest {
  resolutionId: string

  constructor(resolutionId: string) {
    this.resolutionId = resolutionId
  }
}
